import $ from 'jquery';

function numberFormat(num) {
  if (!(this instanceof numberFormat)) {
    return new numberFormat(num);
  }
  this.numStr = Number(num).toString();
}

numberFormat.prototype.addPad = function (digit) {
  if (digit < 1) {
    return this.numStr;
  }
  digit -= this.numStr.length;

  return new Array(digit + (/\./.test(this.numStr) ? 2 : 1)).join('0') + this.numStr;
};

numberFormat.prototype.addComma = function () {
  var parts = this.numStr.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return parts.join('.');
};

numberFormat.prototype.toTags = function (options, classPrefix, suffixTag) {
  var $tag = $('<span></span>');
  var numTags = $('<div></div>');
  var prefix = classPrefix || 'num';
  var unitClassName = {
    조: 'jo',
    억: 'uk',
    만: 'man'
  };

  if (this.numStr === '0') {
    return '<span class="num">0<span>';
  }

  if (options.addComma) {
    this.numStr = this.addComma(this.numStr);
  }

  if (options.toText) {
    this.numStr = this.toText();
  }

  $.each(this.numStr.split(''), function (i, char) {
    if (char === ',') {
      $tag
        .clone()
        .addClass(prefix + 'comma')
        .html(char)
        .appendTo(numTags);
    } else if (/조|억|만/.test(char)) {
      $('<strong></strong>').addClass(unitClassName[char]).html(char).appendTo(numTags);
    } else {
      $tag.clone().addClass(prefix).html(char).appendTo(numTags);
    }
  });

  if (suffixTag) {
    $(suffixTag).appendTo(numTags);
  }
  return numTags.html();
};

numberFormat.prototype.toText = function (options) {
  if (this.numStr === '0') {
    return '0';
  }

  var sign = '';
  var parts;
  var unsignedNumStr;
  var sep = [];
  var revalue = [];
  var unit = ['', '만', '억', '조'];

  if (this.numStr[0] === '-') {
    sign = '-';
    unsignedNumStr = this.numStr.slice(1);
  } else {
    unsignedNumStr = this.numStr;
  }

  options = $.extend(
    {
      delimiter: '',
      comma: false
    },
    options
  );

  parts = unsignedNumStr.split('.');
  parts[0] = parts[0].replace(/,/g, '');
  parts[0] = parts[0].replace(/\B(?=(\d{4})+(?!\d))/g, ',');
  sep = parts[0].split(',');

  $.each(
    sep.reverse(),
    $.proxy(function (index, el) {
      el = parseInt(el, 10);
      if (el > 0) {
        el = options.comma ? this.comma.call({ numStr: el.toString() }) : el.toString();
        el = el + unit[index] + options.delimiter;
      } else {
        el = '';
      }
      revalue.push(el);
    }, this)
  );

  return sign + $.trim(revalue.reverse().join(''));
};

numberFormat.prototype.toShort = function () {
  // 시간 없어 대충 만듬. 양수만 가능.
  if (this.numStr.length < 9) {
    return this.numStr; // 1억 미만
  }
  var ns = this.numStr;

  // 1억이 넘을 경우 천단위까지는 생략한다.
  if (ns.length >= 9 && ns.length < 13) {
    return ns.slice(0, ns.length - 4) + '0000';
  }
  // 1조가 넘는다면 억단위까지만 노출
  return ns.slice(0, ns.length - 8) + '00000000';
};

export function toTextTags(num) {
  return numberFormat(num).toTags({ toText: true });
}

export function toCommaTags(num) {
  return numberFormat(num).toTags({ addComma: true });
}

export function toText(num) {
  return numberFormat(num).toText();
}

export function addComma(num) {
  return numberFormat(num).addComma();
}

export function toShort(num) {
  return numberFormat(num).toShort();
}
